import Api from './api';
import { getInstanceConfig } from '../helpers/instance_helpers';

const apiService = new Api();
const BASE_URL = '/__api/v1';

export const fetchToolTipData = async () => {
  try {
    const res = await apiService.get(`${BASE_URL}/system_tooltips`);
    return res.data;
  } catch (err) {
    console.error('fetchToolTipData error:', err);
    throw err;
  }
};

// The ToolTipManager is a singleton that manages the tooltip data, using a functional approach.
const createToolTipManager = () => {
  let tooltips = [];
  let initialized = false;

  return {
    async init() {
      if (initialized) {
        return;
      }
      try {
        const { features } = getInstanceConfig();
        if (features && features.tool_tips) {
          const data = await fetchToolTipData();
          tooltips = data || [];
        }
        initialized = true;
      } catch (error) {
        console.error("Failed to initialize ToolTipManager:", error);
      }
    },

    getAll() {
      return tooltips;
    },

    getById(id) {
      const tip = tooltips.find(t => t.id === id);
      return tip || { title: 'Not Found', description: 'Tooltip not found' };
    }
  };
};

export const toolTipManager = createToolTipManager();


// WEBPACK FOOTER //
// ./src/services/instanceService.js